export enum SendContractOptions {
  EMAIL = 'EMAIL',
  BOTH = 'BOTH',
  WHATSAPP = 'WHATSAPP',
}
